import { createSlice } from '@reduxjs/toolkit';
import { ITimesheetLock } from '../../../../dto';
import { setTimesheetLocks } from '../actions';
import { MN_TIMESHEET_LOCK, TYPE_LIST } from '../../../../common';

export interface TimesheetLocksState {
  data: ITimesheetLock[];
  loading: boolean;
  error: string | null;
}

const initialState: TimesheetLocksState = {
  data: [],
  loading: false,
  error: null,
};

export const timesheetLocksSlice = createSlice({
  name: `${MN_TIMESHEET_LOCK}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setTimesheetLocks, (state, { payload }) => {
      state.data = payload;
    });
  },
});
